import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '../../assets/img/signup-teamplate-image-nobg.png';
const _withScopeId = n => (_pushScopeId("data-v-3dd6f7f6"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "sidebar-container" };
const _hoisted_2 = { class: "top" };
const _hoisted_3 = { class: "action-button-group" };
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "footer-container" }, [
    /*#__PURE__*/ _createElementVNode("img", {
        class: "footer-image",
        src: _imports_0
    })
], -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_FriedH3 = _resolveComponent("FriedH3");
    const _component_SidebarInfoItem = _resolveComponent("SidebarInfoItem");
    const _component_FriedIcon = _resolveComponent("FriedIcon");
    const _component_FriedButton = _resolveComponent("FriedButton");
    return (_openBlock(), _createElementBlock("div", null, [
        _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
                _createVNode(_component_FriedH3, { class: "title" }, {
                    default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('try-out-this-stunning-template')), 1)
                    ]),
                    _: 1
                }),
                _createVNode(_component_SidebarInfoItem, {
                    text: _ctx.$t('editable-text-and-live-changes'),
                    icon: "edit"
                }, null, 8, ["text"]),
                _createVNode(_component_SidebarInfoItem, {
                    text: _ctx.$t('attach-demo-videos-and-presentations'),
                    icon: "camera"
                }, null, 8, ["text"]),
                _createVNode(_component_SidebarInfoItem, {
                    text: _ctx.$t('negotiate-and-chat-communicate'),
                    icon: "conversation"
                }, null, 8, ["text"]),
                _createVNode(_component_SidebarInfoItem, {
                    text: _ctx.$t('send-for-signatures'),
                    icon: "signature"
                }, null, 8, ["text"]),
                _createElementVNode("div", _hoisted_3, [
                    _createVNode(_component_FriedButton, {
                        "data-external": "signup-template-signup-modal-button",
                        centered: true,
                        onClick: _ctx.signup
                    }, {
                        default: _withCtx(() => [
                            _createVNode(_component_FriedIcon, {
                                class: "icon",
                                icon: "plus-large"
                            }),
                            _createTextVNode(" " + _toDisplayString(_ctx.$t('start-using-this-template')), 1)
                        ]),
                        _: 1
                    }, 8, ["onClick"])
                ])
            ]),
            _hoisted_4
        ])
    ]));
}
